import { Component, Input } from '@angular/core';

export interface AgentixTrialMarketingSlide {
  headlineKey: string;
  subtextKey: string;
}

@Component({
    selector: 'agentix-trial-marketing-panel',
    templateUrl: './agentix-trial-marketing-panel.component.html',
    styleUrls: ['./agentix-trial-marketing-panel.component.scss'],
    standalone: false
})
export class AgentixTrialMarketingPanelComponent {
  @Input() activeSlide = 0;

  readonly slides: AgentixTrialMarketingSlide[] = [
    {
      headlineKey: 'agentix_trial_signup_slide_0_headline',
      subtextKey: 'agentix_trial_signup_slide_0_subtext'
    },
    {
      headlineKey: 'agentix_trial_signup_slide_1_headline',
      subtextKey: 'agentix_trial_signup_slide_1_subtext'
    },
    {
      headlineKey: 'agentix_trial_signup_slide_2_headline',
      subtextKey: 'agentix_trial_signup_slide_2_subtext'
    },
    {
      headlineKey: 'agentix_trial_signup_slide_3_headline',
      subtextKey: 'agentix_trial_signup_slide_3_subtext'
    },
    {
      headlineKey: 'agentix_trial_signup_slide_4_headline',
      subtextKey: 'agentix_trial_signup_slide_4_subtext'
    }
  ];
}
